export default "__VITE_ASSET__P8THSJF4__"